export default __webpack_public_path__ + "static/mob-menu-download-app-4dbfa3d9f6a99a99bf396fa4c70bb48e.gif";